import st from "lib/utils/index"

export const INITIALIZE_VIEW = "integrations/IntegrationsListView/INITIALIZE_VIEW"


const initialState = {}

const reducers = {
  [INITIALIZE_VIEW]: () => initialState,
}

  const epics = [
  (actions$, store) =>
    actions$
      .ofType(INITIALIZE_VIEW)
];

export function initializeView() {
  return { type: INITIALIZE_VIEW }
}

export default st.duck.createDuck(initialState, reducers, epics)


// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepIntegrations/index.js